// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { HolderService } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Holder';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useLedgerEnd } from '../../ledger/useLedgerEnd';

const useHolderService: () => UseQueryResult<
  TemplateContract<HolderService> | null,
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator, party } = useParties();
  const offset = useLedgerEnd();
  return useQuery({
    queryKey: ['queryRegistryHolderService', offset, ledgerApi, operator, party],
    queryFn: async () => {
      return ledgerApi.queryRegistryHolderService(offset!, operator, party);
    },
    enabled: !!offset,
    refetchInterval: false,
  });
};

export default useHolderService;
